import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("");

const sendEmail = (e) => {
  e.preventDefault();
   emailjs
      .sendForm(
        "service_exchnan",
        "template_drrm2ot",
        form.current,
        "7_7S84dMoew2A36rs"
 )
    .then(
      () => {
        setStatus("success");
        e.target.reset();
      },
      () => {
        setStatus("error");
      }
    );
};

  return (
    <section id="contact" className="contact-section contact-page">
      <h2 className="contact-title">Get In Touch</h2>

<p className="contact-subtitle">
  I’m always open to discussing new opportunities, collaborations, 
  or freelance projects. Feel free to reach out and I’ll get back to you as soon as possible.
</p>


      <div className="contact-card">
        <form ref={form} onSubmit={sendEmail}>
          
          {/* NAME */}
          <div className="input-group">
            <input
              type="text"
              name="user_name"
              required
            />
            <label>Your Name</label>
          </div>

          {/* EMAIL */}
          <div className="input-group">
            <input
              type="email"
              name="user_email"
              required
            />
            <label>Your Email</label>
          </div>

          {/* MESSAGE */}
          <div className="input-group">
            <textarea
              name="message"
              rows="4"
              required
            ></textarea>
            <label>Your Message</label>
          </div>

          <button type="submit" className="contact-btn">
            Send Message
          </button>
{status === "success" && (
  <div className="form-message success">
    ✅ Your message has been sent successfully. I’ll get back to you soon.
  </div>
)}

{status === "error" && (
  <div className="form-message error">
    ❌ Something went wrong. Please try again later.
  </div>
)}

        </form>
      </div>
    </section>
  );
}

export default Contact;
